import React, { useEffect, useState } from 'react'
import BannerSlide from '../../../components/banner-slide/BannerSlide'
import { FrontApi } from '../../../api/front-api/front.api'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { MainContainer } from '../../../components/container/container'
import { Box, Button, Typography } from '@mui/material'
import DescriptionIcon from '@mui/icons-material/Description';
import { ImageListGallery } from '../gallery/[id_gallery]/page'
import { RootState } from '../../../store/store'
import HtmlRenderer from '../../../components/render-html/RenderHtml'
import { BANNER_TYPE } from '../../cms-website/website-structure/content/enum/content.enum'
import { useNavigate } from 'react-router-dom'
import { routeName } from '../../../routes/routeName'

type Props = {}

const AdmissionWebsite: React.FC<Props> = ({ }: Props) => {
    const dispatch = useDispatch();
    const base_url = useSelector((state: RootState) => state.api.image_api);
    const navigate = useNavigate()
    const [banner_data, set_banner_data] = useState<any[]>([]);
    const [dataDetail, setDataDetail] = useState<any>(null);
    const [content_vdo_files, set_content_vdo_files] = useState<any[]>([]);
    const handleGetBannerSlide = async () => {
        dispatch(setLoading());
        await FrontApi.banner({ limit: 10, page: 1, banner_group: 'ADMISSION' }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_banner_data(response);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetData = async () => {
        dispatch(setLoading());
        await FrontApi.admission().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                set_content_vdo_files(response?.content_vdo_files || []);
                setDataDetail(response);
                console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    useEffect(() => {
        handleGetBannerSlide();
        handleGetData();
    }, [])
    return (
        <div>
            <BannerSlide
                banner_type={BANNER_TYPE.TYPE_ONE}
                banner_slide={banner_data || []}
            />
            <MainContainer sx={{ my: "5rem" }}>
                <Box className="flex flex-col gap-4" sx={{ maxWidth: { lg: "1240px", xl: "1440px" }, width: "100%", margin: "0 auto" }}>
                    <Button startIcon={<DescriptionIcon />} sx={{ bgcolor: "#9E640E" }} fullWidth variant='contained' onClick={() => {
                        navigate(routeName.admission.IBSCOnlineAdmission)
                    }}>
                        Admission Form
                    </Button>
                    <Box>
                        <Typography variant='h5'>
                            College Introduction Video
                        </Typography>
                        <Typography>
                            International Buddhist Studies College: IBSC
                        </Typography>
                    </Box>
                    <Box>
                        <ImageListGallery
                            is_video
                            itemData={content_vdo_files?.map((list) => {
                                const url = list?.gallery_link ? list?.gallery_link : list?.file_path ? `${base_url}/${list?.file_path}${list?.file_name}` : ""
                                return {
                                    img: url,
                                    alt: list?.file_name || ""
                                }
                            })}
                        />
                    </Box>
                    <Box className="w-full m-auto">
                        <HtmlRenderer
                            html={dataDetail?.content_detail || ""}
                        />
                    </Box>
                </Box>
            </MainContainer>
        </div>
    )
}

export default AdmissionWebsite